import React from "react";
import { CheckIcon } from "lucide-react";
import { images, offerItems, price } from "../data/landing";
import { CtaButton } from "./CtaButton";
export function OfferSummary() {
  return <section id="oferta" className="scroll-mt-4 bg-lilac/50" data-id="element-98" data-mp="1f1pv0vgax1nr">
      <div className="mx-auto max-w-6xl px-5 py-16 md:py-20" data-id="element-99" data-mp="1ez3motll6i4h">
        <img src={images.bundle} alt="Colección completa del MegaPack Arteterapia: los 6 tomos más los 3 bonos extra" className="mx-auto w-full max-w-4xl rounded-3xl shadow-[0_24px_60px_-30px_rgba(94,43,151,0.45)]" loading="lazy" data-id="element-100" data-mp="1a34qiju0nvti" />
        <div className="mx-auto mt-12 max-w-xl rounded-3xl bg-paper p-6 shadow-[0_24px_60px_-30px_rgba(94,43,151,0.45)] sm:p-8" data-id="element-101" data-mp="w2ty3cd26968">
          <h2 className="text-center font-display text-2xl font-bold text-ink" data-id="element-102" data-mp="ra0wuygstiyw">Todo esto lo recibes hoy</h2>

          <ul className="mt-6 divide-y divide-line" data-id="element-103" data-mp="3k6l6k87u0g8">
            {offerItems.map(item => <li key={item.label} className="flex items-start gap-3 py-4" data-id="element-104" data-mp="3urstiq5vqr3f">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-emerald-50" data-id="element-105" data-mp="1chtnhop5gojr">
                  <CheckIcon className="h-4 w-4 text-emerald-700" aria-hidden="true" data-id="element-106" data-mp="1gix1s6rjuciv" />
                </span>
                <div data-id="element-107" data-mp="1lbyh2fvo4e2z">
                  <p className={`font-extrabold ${item.main ? "text-plum" : "text-berry"}`} data-id="element-108" data-mp="1qa9t8x9fr0od">{item.label}</p>
                  <p className="text-ink" data-id="element-109" data-mp="tk0lcomcoinf">{item.detail}</p>
                </div>
              </li>)}
          </ul>

          <div className="mt-4 border-t-2 border-dashed border-line pt-6 text-center" data-id="element-110" data-mp="xku8hfryxtf9">
            <p className="text-sm font-extrabold uppercase tracking-wide text-muted" data-id="element-111" data-mp="12k5p8osc4ywu">Precio especial</p>
            <p className="mt-1 font-display text-5xl font-bold text-plum" data-id="element-112" data-mp="17k1v6tklf0f1">{price}</p>
            <p className="mt-2 font-bold text-ink" data-id="element-113" data-mp="2e04273qmw53c">Un único pago.</p>
          </div>

          <div className="mt-6" data-id="element-114" data-mp="2iyyls7wfdxoi">
            <CtaButton label="¡Quiero acceder al MegaPack!" href="#" data-id="element-115" data-mp="2iy5k3lcbpyd8" />
          </div>
        </div>
      </div>
    </section>;
}